// extracted by mini-css-extract-plugin
export default {"name":"Details_name__ve9Oz","container":"Details_container__CTmee","imgDetails":"Details_imgDetails__GCQso","back":"Details_back__MXcKG","info":"Details_info__aTJK0"};